<script>
    
    import { toast } from 'bulma-toast'
    import { userStore, notifyStore } from '../stores'

    import StorageService from '../$services/storage.service'
    import FacturamaService from '../$services/facturama.service'

    import ZipcodeColonyComponent from '../locations/component.zipcode.colony.svelte'
    import Spinner from '../$components/spinner.svelte'

    const data = {location: {}}
    let loading = false

    async function createClient() {

        loading = true
        const resp = await FacturamaService.createClient(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        StorageService.setItem('user', resp.data)
        userStore.set(resp.data)
        notifyStore.set('facturama_updated')
    }

</script>

<div class="title">Datos de facturación</div>

<Spinner {loading} />

{#if !loading}
    <form on:submit|preventDefault={createClient} >

        <div class="field">
            <label for="" class="label">Nombre</label>
            <div class="control has-icons-left">
                <span class="icon"><i class="fas fa-address-card"></i></span>
                <input bind:value={data.name} type="text" class="input" placeholder="Nombre" required>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">RFC</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-fingerprint"></i></span>
                        <input bind:value={data.rfc} type="text" class="input" placeholder="RFC" required>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Correo electronico</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-envelope"></i></span>
                        <input bind:value={data.email} type="email" class="input" placeholder="Correo electronico" required>
                    </div>
                </div>
            </div>
        </div>

        <ZipcodeColonyComponent 
            bind:zipcode={data.location.zipcode}
            bind:state={data.location.state}
            bind:city={data.location.city}
            bind:municipality={data.location.municipality}
            bind:colony={data.location.colony}
        />
        
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Calle</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                        <input bind:value={data.location.street} type="text" class="input" placeholder="Calle" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Número exterior</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-hashtag"></i></span>
                        <input bind:value={data.location.number} type="text" class="input" placeholder="Número exterior de casa/apartamento" required>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Número interior</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-building"></i></span>
                        <input bind:value={data.location.apartment} type="text" class="input" placeholder="Número interior del apartamento">
                    </div>
                </div>
            </div>
        </div>
        <div class="items-end">
            <button type="submit" class="button is-primary">
                <span class="icon"><i class="fas fa-save"></i></span>
                <span>Guardar</span>
            </button>
        </div>
    </form>
{/if}